import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import { createUserWithEmailAndPassword, GoogleAuthProvider, signInWithPopup, updateProfile } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Image from "../assets/image.png";
import Logo from "../assets/logo.png";
import GoogleSvg from "../assets/icons8-google.svg";
import { FaEye, FaEyeSlash } from "react-icons/fa6";

const SignUp = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [dob, setDob] = useState(""); // Date of Birth
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSignedUp, setIsSignedUp] = useState(false); // New state for tracking sign-up

  const navigate = useNavigate(); // Hook for navigation

  // Regular expressions for validation
  const phoneRegex = /^07\d{9}$/; // Must start with 07 and followed by 9 digits
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/; // At least 8 characters, 1 uppercase, 1 lowercase, 1 number, 1 special character

  // Google Sign-Up
  const handleGoogleSignUp = async () => {
    const provider = new GoogleAuthProvider();
    try {
      setLoading(true);
      await signInWithPopup(auth, provider);
      toast.success("Successfully signed up with Google!");
      setIsSignedUp(true);
    } catch (err) {
      console.error("Google sign-up error:", err);
      toast.error("Google sign-up failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  // const handleSignUp = async (e) => {
  //   e.preventDefault();

  //   if (!firstName || !lastName || !email || !password || !phone || !dob) {
  //     toast.error("Please fill in all required fields.");
  //     return;
  //   }

  //   // Phone validation
  //   if (!phoneRegex.test(phone)) {
  //     toast.error("Phone number must be in the format 07XXXXXXXXX");
  //     return;
  //   }

  //   // Password validation
  //   if (!passwordRegex.test(password)) {
  //     toast.error("Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.");
  //     return;
  //   }

  //   try {
  //     setLoading(true);
  //     // Create user in Firebase Authentication
  //     const userCredential = await createUserWithEmailAndPassword(auth, email, password);
  //     const user = userCredential.user;

  //     // Set display name
  //     await updateProfile(user, {
  //       displayName: `${firstName} ${lastName}`,
  //     });

  //     // Save user data in Firestore
  //     const userRef = doc(db, "users", user.uid);
  //     await setDoc(userRef, {
  //       firstName,
  //       lastName,
  //       email,
  //       phone,
  //       dob,
  //       createdAt: new Date(),
  //     });

  //     toast.success("Account created successfully!");
  //     setIsSignedUp(true); // Set to true to indicate sign-up was successful
  //   } catch (err) {
  //     console.log("Sign-up error:", err);
  //     switch (err.code) {
  //       case "auth/email-already-in-use":
  //         toast.error("This email is already in use.");
  //         break;
  //       case "auth/invalid-email":
  //         toast.error("Invalid email format.");
  //         break;
  //       case "auth/weak-password":
  //         toast.error("Weak password. Please choose a stronger password.");
  //         break;
  //       default:
  //         toast.error("Sign-up failed. Please try again later.");
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  // Redirect to homepage after successful sign-up


  const handleSignUp = async (e) => {
    e.preventDefault();
  
    if (!firstName || !lastName || !email || !password || !phone || !dob) {
      toast.error("Please fill in all required fields.");
      return;
    }
  
    // Phone validation
    if (!phoneRegex.test(phone)) {
      toast.error("Phone number must be in the format 07XXXXXXXXX");
      return;
    }
  
    // Password validation
    if (!passwordRegex.test(password)) {
      toast.error("Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.");
      return;
    }
  
    // Date of Birth validation
    const selectedDate = new Date(dob);
    const currentDate = new Date();
    const ageDifference = currentDate.getFullYear() - selectedDate.getFullYear();
    const isBirthdayPassed = 
      currentDate.getMonth() > selectedDate.getMonth() || 
      (currentDate.getMonth() === selectedDate.getMonth() && currentDate.getDate() >= selectedDate.getDate());
  
    if (selectedDate > currentDate) {
      toast.error("Date of birth cannot be in the future.");
      return;
    }
  
    if (ageDifference < 18 || (ageDifference === 18 && !isBirthdayPassed)) {
      toast.error("You must be at least 18 years old to sign up.");
      return;
    }
  
    try {
      setLoading(true);
      // Create user in Firebase Authentication
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
  
      // Set display name
      await updateProfile(user, {
        displayName: `${firstName} ${lastName}`,
      });
  
      // Save user data in Firestore
      const userRef = doc(db, "users", user.uid);
      await setDoc(userRef, {
        firstName,
        lastName,
        email,
        phone,
        dob,
        createdAt: new Date(),
      });
  
      toast.success("Account created successfully!");
      setIsSignedUp(true); // Set to true to indicate sign-up was successful
    } catch (err) {
      console.log("Sign-up error:", err);
      switch (err.code) {
        case "auth/email-already-in-use":
          toast.error("This email is already in use.");
          break;
        case "auth/invalid-email":
          toast.error("Invalid email format.");
          break;
        case "auth/weak-password":
          toast.error("Weak password. Please choose a stronger password.");
          break;
        default:
          toast.error("Sign-up failed. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };
  


  useEffect(() => {
    if (isSignedUp) {
      const timer = setTimeout(() => {
        navigate("/"); // Redirect to homepage after 5 seconds
      }, 5000);

      return () => clearTimeout(timer); // Cleanup timeout on component unmount
    }
  }, [isSignedUp, navigate]);

  return (
    <div className="login-main">
      <div className="login-left">
      <a href="/"><img src={Image} alt="Background" /></a>
      </div>
      <div className="login-right">
        <div className="login-right-container">
          <div className="login-logo">
            <img src={Logo} alt="Logo" />
          </div>
          <div className="login-center">
            <h2 className="login-text">Create an account</h2>
            <form onSubmit={handleSignUp}>
              <input
                type="text"
                placeholder="First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
              />
              <input
                type="text"
                placeholder="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
              />
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <input
                type="tel"
                placeholder="Phone Number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
              <input
                type="date"
                placeholder="Date of Birth"
                value={dob}
                onChange={(e) => setDob(e.target.value)}
                required
              />
              <div className="pass-input-div">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                {showPassword ? (
                  <FaEyeSlash onClick={() => setShowPassword(!showPassword)} />
                ) : (
                  <FaEye onClick={() => setShowPassword(!showPassword)} />
                )}
              </div>

              <div className="login-center-buttons">
                <button type="submit" disabled={loading}>
                  {loading ? "Signing up..." : "Sign Up"}
                </button>
                {/* <button
                  type="button"
                  onClick={handleGoogleSignUp}
                  disabled={loading}
                >
                  <img src={GoogleSvg} alt="Google Icon" />
                  Sign Up with Google
                </button> */}
              </div>
            </form>
          </div>
          <p className="login-bottom-p">
            Already have an account? <a href="/">Log In</a>
          </p>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar />
    </div>
  );
};

export default SignUp;

